import { only } from "../../lib/base.js";
import { Configurable } from "../../lib/configurable.js";
import "deepmerge";
const config = Configurable.props({
  topLevelDomain: "ro",
  locale: "en_RO"
});
const RO = {
  en_RO: only("adidas", config)
};
export {
  RO
};
//# sourceMappingURL=RO.js.map
